import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    envioConDeuda: false,
    monto: null,
    isLoading: true
};

const envioConDeudaSlice = createSlice({
    name: 'envioConDeuda',
    initialState,
    reducers: {
        setEnvioConDeuda: (state, {payload}) => {
            state.envioConDeuda = payload.envioConDeuda;
            state.monto = payload.monto;
        },
        clearEnvioConDeuda: (state) => {
            state.envioConDeuda = null;
        },
        setLoading: (state, {payload}) => {
            state.isLoading = payload;
        },
    },
});

export const { setEnvioConDeuda, clearEnvioConDeuda, setLoading } = envioConDeudaSlice.actions;

export default envioConDeudaSlice.reducer;


